import React from "react"; // eslint-disable-line no-unused-vars
import { withRouter } from "react-router-dom";
import ReactSelect from "react-select";
import { RingLoader } from "react-spinners";
import InputGroup from "../../../forms/InputGroup";
import { api } from "../../index.api";
import { COUNTRIES, REF_DATA } from "../../../constants";
import { addNotification as notify } from "reapop";
import connect from "react-redux/es/connect/connect";
import { validateField, submitForm } from "../../../pages/functions";
import AdminNavigation from "../AdminNavigation";
import { getCookie } from "../../../helpers/CookieHandler";
import { getApplicationRegex } from "../../plugins/utils";
import EditDetails from "./EditDetails";

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

class AddProduct extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        affiliate: {
          name: "affiliate",
          value: [],
          rules: { title: "Affiliate", required: true },
          error: "Affiliate List cannot be empty",
        },
        name: {
          name: "productName",
          value: "",
          rules: { title: "Product Name", required: true },
        },
        productCode: {
          name: "prodcode",
          value: "",
          rules: { title: "Product Code", required: true },
        },
        veevaproductCode: {
          name: "veevacode",
          value: "",
          rules: { title: "Veeva Product Code", required: true },
        },
        prescriptionUrl: {
          name: "prescriptionUrl",
          value: "",
          rules: {
            title: "Prescription Information Search URL (Optional)",
          },
          error: "Enter a correct URL!!",
        },
      },
      internalchecked: false,
      externalchecked: false,
      conferencechecked: false,
      allergenEmployeechecked: false,
      allergenchecked:false, // allergenchecked:false
      allergenPatientchecked: false,
      externalsearchchecked: false,
      internalsearchchecked:false,
      allAffiliatesChecked: false,
      dropdownAffiliates: [],
      patientchecked: false,
      isUrlCorrect: false,
      isAffiliateEmpty: false,
      urlFlag: false,
      isAdmin: false,
      loading: true,
      table: [],
      isModalOpen: false,
    };
  }

  _validate = (e, field) => {
    const inputValue = e.target.value.toLowerCase();
    const ref_Data = this.props.referenceData.find(function (category) {
      return category.type === REF_DATA;
    }).referenceData;
    const regex = getApplicationRegex(ref_Data);

    if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
      // Emoji detected, prevent it from being added
      this._showNotification(
        "Error!",
        "Special characters are not allowed",
        "error"
      );
      return;
    } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
      // HTML Tags and Script detected, prevent it from being added
      this._showNotification(
        "Error!",
        "Submission fails. Input contains prohibited words. Please remove them and try again.",
        "error"
      );
      return;
    } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
      this._showNotification(
        "Error!",
        "Validation configuration is missing. Please contact support.",
        "error"
      );
      return;
    }
    const fields = validateField(e, field, this.state.fields);
    this.setState({ fields });
    return false;
  };

  _showNotification = (title, message, status) => {
    const { notify } = this.props;
    notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 6000,
    });
  };

  handleSaveClick = (e) => {
    const fields = submitForm(e, this.state.fields);
    this.setState({ fields });
    for (const key in fields) {
      if (fields[key].errors.length > 0) {
        return false;
      }
    }
    if (
      this.state.fields.prescriptionUrl.value.length > 0 &&
      !this.validateURL()
    ) {
      this.setState({ urlFlag: true });
      return false;
    } else {
      this.setState({ urlFlag: false });
    }
    if (this.validateAffiliate()) {
      return false;
    }
    const addProduct = this._createProductObject();

    api.admin.addProduct.addProductname(
      addProduct,
      this._updateProductSuccessHandler.bind(this),
      this._updateProductFailureHandler.bind(this)
    );
  };

  _reset() {
    const { fields } = this.state;
    for (var key in fields) {
      fields[key].value = "";
      fields[key].errors = [];
    }
    this.setState({
      fields,
      internalchecked: false,
      externalchecked: false,
      conferencechecked: false,
      allergenEmployeechecked:false,
      allergenPatientchecked:false,
      allergenchecked: false,
      externalsearchchecked: false,
      internalsearchchecked:false,
      allAffiliatesChecked: false,
      dropdownAffiliates: [],
      patientchecked: false,
      isUrlCorrect: false,
      isAffiliateEmpty: false,
      urlFlag: false,
      table: [],
      isModalOpen:false,
    });
  }

  _updateProductSuccessHandler = (response) => {
    if (response.status === 201) {
      this._reset();
      this._showNotification(
        "Success",
        "Product added successfully.",
        "success"
      );
      setTimeout(() => this.props.history.push("/admin/edit-products"), 2000);
    } else if (response.status === 401) {
      this._showNotification(
        "Error",
        "You are not authorized to perform this action. Please log in again.",
        "error"
      );
      setTimeout(() => window.location.replace("/"), 3000);
    } else if (response.status === 417) {
      response.json().then((data) => {
        this.setState({ table: data });
        this._showNotification(
          "Information",
          "Product Code and Affiliate combination already exist with different product Id.",
          "info"
        );
      });
    } else {
      this._showNotification(
        "Error",
        "There seems to be some error while adding product ",
        "error"
      );
    }
  };

  _updateProductFailureHandler = (error) => {
    /* eslint-disable-line */
    this._showNotification(
      "Error",
      "There seems to be an error at our server side. Please try later.",
      "error"
    );
  };

  onChange = (fieldname) => {
    this.setState({ [fieldname]: !this.state[fieldname] });
  };

  _createProductObject = () => {
    const affiliateValues = this.state.allAffiliatesChecked
      ? this.affiliateList
      : this.state.fields.affiliate.value;

    return {
      affiliates: affiliateValues,
      name: this.state.fields.name.value,
      productCode: this.state.fields.productCode.value,
      veevaProductCode: this.state.fields.veevaproductCode.value,
      availableToInternalUsers: this.state.internalchecked,
      availableForConference: this.state.conferencechecked,
      availableForAllergen: this.state.allergenchecked,
      availableForAllergenPatient: this.state.allergenPatientchecked,
      availableToExternalForSearch: this.state.externalsearchchecked,
      availableToExternalUsers: this.state.externalchecked,
      piSearchLinks: this.state.fields.prescriptionUrl.value,
      patientPortalApproved: this.state.patientchecked,
      availableForAllergenEmployee: this.state.allergenEmployeechecked,
      availableToEmployeeForSearch : this.state.internalsearchchecked
    };
  };
  handleAffiliateChange = (selected) => {
    this.setState({table:[]});
    if (selected && selected.length > 0) {
      this.setState({
        dropdownAffiliates: selected,
        fields: {
          ...this.state.fields,
          affiliate: {
            ...this.state.fields.affiliate,
            value: selected.map((option) => option.value),
          },
        },
      });
    } else {
      // If no options are selected, reset both dropdown and affiliate value
      this.setState({
        dropdownAffiliates: [],
        fields: {
          ...this.state.fields,
          affiliate: {
            ...this.state.fields.affiliate,
            value: [],
          },
        },
      });
    }
  };
  validateURL = () => {
    const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    const ref_Data = this.props.referenceData.find(function (category) {
      return category.type === REF_DATA;
    }).referenceData;
    const regex = getApplicationRegex(ref_Data);
    
    const isUrlCorrect =
      !regex.Script_Regex.test(this.state.fields.prescriptionUrl.value) &&
      !regex.Emoji_Regex.test(this.state.fields.prescriptionUrl.value) &&
      urlRegex.test(this.state.fields.prescriptionUrl.value);

    // Update the state for the isUrlCorrect flag and any errors in the fields
    this.setState((prevState) => ({
      isUrlCorrect,
      fields: {
        ...prevState.fields,
        prescriptionUrl: {
          ...prevState.fields.prescriptionUrl,
          error: isUrlCorrect ? "" : "Enter a correct URL!!",
        },
      },
    }));

    return isUrlCorrect;
  };

  validateAffiliate = () => {
    const isAffiliateEmpty =
      !this.state.allAffiliatesChecked &&
      this.state.fields.affiliate.value.length === 0;

    // Update the state for the isAffiliateEmpty flag and any errors in the fields
    this.setState((prevState) => ({
      isAffiliateEmpty,
      fields: {
        ...prevState.fields,
        affiliate: {
          ...prevState.fields.affiliate,
          error: isAffiliateEmpty ? "Affiliate List cannot be empty" : "",
        },
      },
    }));

    return isAffiliateEmpty;
  };

  handleInputChange = (e, field) => {
    const updatedFields = {
      ...this.state.fields,
      [field.name]: {
        ...field,
        value: e.target.value,
        error: "", // Don't set errors when modifying input directly
      },
    };
    this.setState({ fields: updatedFields });
  };

  componentDidMount() {
    // Get the cookie when the component mounts
    const jwtToken = getCookie("jwtToken");
    const userRole = getCookie("welcomeRole");
    if (jwtToken && userRole === "ABBVIE_EMPLOYEE") {
      api.admin.addProduct.ValidateAdminUser((response) => {
        if (response.status === 200) {
          this.setState({ isAdmin: true, loading: false });
        } else {
          this.setState({ isAdmin: false, loading: false });
        }
      });
    } else {
      this.setState({ isAdmin: false, loading: false });
    }
  }

  handleEditClick = () => {
    if (this.state.table.length > 0) {
      this.setState({ isModalOpen: true });
    }
  };

  render() {
    const languageContent = this.props.pageContent.content;
    this.countryList = this.props.referenceData.filter(function (item) {
      return item.type === COUNTRIES;
    })[0].countries;
    this.affiliateList = this.countryList.map((c) => c.affiliate);
    this.affiliateList = this.affiliateList.filter(onlyUnique).sort();
    this.affiliateOptions = this.affiliateList.map(function (affiliate) {
      return {
        value: affiliate,
        label: affiliate,
      };
    });

    return (
      <div>
        {this.state.loading && <RingLoader color="#071d49" loading />}
        {!this.state.loading && this.state.isAdmin && (
          <div className="v2_container">
            <div className="row">
              {this.state.isModalOpen && (
              <EditDetails
                isModalOpen={this.state.isModalOpen}
                productObject={this.state.table[0]}
                setIsModalClose={()=>this.setState({isModalOpen:false})}
                validate={this._validate}
                history = {this.props.history}
                showNotification={this._showNotification}
              />
            )}
            <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
              <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
                <div className="row">
                  <div className="col-12 col-xl-12">
                    <h3 className="mb-3 header-primary">Affiliate Product</h3>
                    <p>Please select Affiliate to add product</p>
                  </div>
                </div>
                <div className="row  mb-1">
                  <div className="col-md-4 ">
                    <label className="custom-control custom-checkbox mr-0">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={this.state.allAffiliatesChecked}
                        onChange={this.onChange.bind(
                          this,
                          "allAffiliatesChecked"
                        )}
                      />
                      <span className="custom-control-indicator" />
                      <span className="custom-control-description">
                        All Affiliates
                      </span>
                    </label>
                  </div>
                </div>
                {!this.state.allAffiliatesChecked && (
                  <div>
                    <div className="row mb-2">
                      <div className="col-md-4">
                        <ReactSelect
                          value={this.state.dropdownAffiliates}
                          onChange={this.handleAffiliateChange}
                          options={this.affiliateOptions}
                          multi
                          clearable={false}
                          searchable={true}
                        />
                      </div>
                    </div>
                    {this.state.isAffiliateEmpty && (
                      <div
                        className="row md-2"
                        style={{ marginBottom: "10px" }}
                      >
                        <div
                          className=" col-md-4"
                          style={{ color: "red", fontWeight: "bold" }}
                        >
                          {this.state.fields.affiliate.error}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                <div className="row">
                  <div className="col-12 col-xl-12">
                    <h4 className="mb-3 header-primary">
                      Please enter a Product Code, Name And Veeva Product Code
                    </h4>
                    <p>Veeva Product Code must match with GMIS product</p>
                  </div>
                </div>
                <div className="row  mb-4">
                  <div className=" col-md-4">
                    <InputGroup
                      searchable={false}
                      clearable={false}
                      field={this.state.fields.name}
                      validate={(e, field) =>
                        this._validate(e, this.state.fields.name)
                      }
                    />
                  </div>
                </div>
                <div className="row  mb-4">
                  <div className=" col-md-4">
                    <InputGroup
                      searchable={false}
                      clearable={false}
                      maxLength={4}
                      field={this.state.fields.productCode}
                      validate={(e, field) =>
                        this._validate(e, this.state.fields.productCode)
                      }
                    />
                  </div>
                </div>

                <div className="row  mb-4">
                  <div className=" col-md-4">
                    <InputGroup
                      searchable={false}
                      clearable={false}
                      field={this.state.fields.veevaproductCode}
                      validate={(e, field) =>
                        this._validate(e, this.state.fields.veevaproductCode)
                      }
                    />
                  </div>
                </div>
                <div className="row  mb-4">
                  <div className="col-md-4">
                    <InputGroup
                      field={this.state.fields.prescriptionUrl}
                      validate={(e, field) =>
                        this._validate(e, this.state.fields.prescriptionUrl)
                      }
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                {!this.state.fields.isUrlCorrect &&
                  this.state.fields.prescriptionUrl.value.length > 0 &&
                  this.state.urlFlag && (
                    <div className="row md-4">
                      <div
                        className="col-md-4"
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          marginBottom: "10px",
                          marginTop: "-10px",
                        }}
                      >
                        {this.state.fields.prescriptionUrl.error}
                      </div>
                    </div>
                  )}
                <div>
                  <div className="{hasErrors ? 'col form-group has-danger' : 'col form-group'}">
                    <div className="col-lg-12">
                      <label className="custom-control custom-checkbox mr-0">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          checked={this.state.internalchecked}
                          onChange={this.onChange.bind(this, "internalchecked")}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          <b>Employee </b>{" "}
                          <i style={{ fontWeight: "100" }}>
                            Product Visibility
                          </i>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="{hasErrors ? 'col form-group has-danger' : 'col form-group'}">
                    <div className="col-lg-12">
                      <label className="custom-control custom-checkbox mr-0">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          checked={this.state.externalchecked}
                          onChange={this.onChange.bind(this, "externalchecked")}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          <b>HCP </b>
                          <i style={{ fontWeight: "100" }}>
                            Product Visibility
                          </i>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="{hasErrors ? 'col form-group has-danger' : 'col form-group'}">
                    <div className="col-lg-12">
                      <label className="custom-control custom-checkbox mr-0">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          checked={this.state.patientchecked}
                          onChange={this.onChange.bind(this, "patientchecked")}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          <b>Patient </b>
                          <i style={{ fontWeight: "100" }}>
                            Product Visibility
                          </i>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="{hasErrors ? 'col form-group has-danger' : 'col form-group'}">
                    <div className="col-lg-12">
                      <label className="custom-control custom-checkbox mr-0">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          checked={this.state.conferencechecked}
                          onChange={this.onChange.bind(
                            this,
                            "conferencechecked"
                          )}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          <b>Conference & Scibooth</b>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="{hasErrors ? 'col form-group has-danger' : 'col form-group'}">
                    <div className="col-lg-12">
                      <label className="custom-control custom-checkbox mr-0">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          checked={this.state.internalsearchchecked}
                          onChange={this.onChange.bind(
                            this,
                            "internalsearchchecked"
                          )}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          <b>Document Search </b>{" "}
                          <i style={{ fontWeight: "100" }}>Employee</i>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="{hasErrors ? 'col form-group has-danger' : 'col form-group'}">
                    <div className="col-lg-12">
                      <label className="custom-control custom-checkbox mr-0">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          checked={this.state.externalsearchchecked}
                          onChange={this.onChange.bind(
                            this,
                            "externalsearchchecked"
                          )}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          <b>Document Search </b>{" "}
                          <i style={{ fontWeight: "100" }}>HCP</i>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="{hasErrors ? 'col form-group has-danger' : 'col form-group'}">
                  <div className="col-lg-12">
                    <label className="custom-control custom-checkbox mr-0">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={this.state.allergenEmployeechecked}
                        onChange={this.onChange.bind(this, "allergenEmployeechecked")}
                      />
                      <span className="custom-control-indicator" />
                      <span className="custom-control-description">
                        <b>Allergen </b>
                        <i style={{ fontWeight: "100" }}>Employee</i>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="{hasErrors ? 'col form-group has-danger' : 'col form-group'}">
                  <div className="col-lg-12">
                    <label className="custom-control custom-checkbox mr-0">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={this.state.allergenchecked}
                        onChange={this.onChange.bind(this, "allergenchecked")}
                      />
                      <span className="custom-control-indicator" />
                      <span className="custom-control-description">
                        <b>Allergen </b>
                        <i style={{ fontWeight: "100" }}>HCP</i>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="{hasErrors ? 'col form-group has-danger' : 'col form-group'}">
                  <div className="col-lg-12">
                    <label className="custom-control custom-checkbox mr-0">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={this.state.allergenPatientchecked}
                        onChange={this.onChange.bind(
                          this,
                          "allergenPatientchecked"
                        )}
                      />
                      <span className="custom-control-indicator" />
                      <span className="custom-control-description">
                        <b>Allergen </b>
                        <i style={{ fontWeight: "100" }}>Patient</i>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col form-group text-left">
                    <button
                      type="submit"
                      onClick={this.handleSaveClick}
                      className="btn btn-lg btn-info btn-rounded"
                    >
                      Add Product & Next
                    </button>
                  </div>
                </div>
                {this.state.table.length > 0 && (
                <div
                  className="row"
                  style={{ paddingTop: "20px", width: "100%" }}
                >
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Affiliate
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Product Name
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Product Code
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Veeva Code
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          PI Url
                        </th>
                        <th
                          colSpan={2}
                          style={{ border: "1px solid #fff" }}
                        ></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.table.map((entry, index) => (
                        <tr key={index} style={{ textAlign: "center" }}>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.affiliate}
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.name}
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.productCode}
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.veevaProductCode}
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.piSearchLinks || ""}
                          </td>
                          <td style={{ border: "1px solid #fff" }}>
                            <button
                              className="btn btn-lg btn-info btn-rounded"
                              onClick={this.handleEditClick}
                            >
                              Edit Product
                            </button>{" "}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              </div>
            </div>
          </div>
        )}
        {!this.state.loading && !this.state.isAdmin && (
          <div className="v2_container">
            <h1>Sorry! you are not able to access this page</h1>
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    referenceData: state.referenceData,
    pageContent: state.pageContent,
  };
}

export default withRouter(connect(mapStateToProps, { notify })(AddProduct));



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Product_Mangement/AddProduct.js